import Vue from 'vue'
import i18n from './i18n'

import { firebase, firebaseConfig } from "./firebase"

import App from './App.vue'
import router from './router'
import store from './stores'

import api from './services/api.service'
import { get } from 'lodash'

/**
 * Register Service Worker
 */
import './registerServiceWorker'

import Vuetify from 'vuetify'

import vuetifything from './vuetify'

// @todo find a better spot for directives
// Do we really want to import moment globally?
// Maybe assign to a global vue param so its easily accessible in other files then
import { formatDate, formatMoney } from "./services/util.service"

import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete';

Vue.use(VuetifyGoogleAutocomplete, {
  apiKey: process.env.VUE_APP_GOOGLE_API_KEY, // Can also be an object. E.g, for Google Maps Premium API, pass `{ client: <YOUR-CLIENT-ID> }`
});

Vue.use(Vuetify)

Vue.config.productionTip = false

Vue.directive('date', (el, binding) => {
  const formattedDate = formatDate(binding.value)
  el.innerText = formattedDate
})

Vue.directive('money', (el, binding) => {
  el.innerText = formatMoney(binding.value)
})

/**
 * ====== Init Firebase App =====
 */
firebase.initializeApp(firebaseConfig)

/**
 * These variables MUST come AFTER `firebase.initializeApp()`
 */
const db = firebase.firestore()
const storage = firebase.storage()


store.$firebase = firebase
store.$db = db
store.$storage = storage
store.$api = api
store.$router = router
Vue.prototype.$storage = storage

let app

const createApp = () => {
  app = new Vue({
    router,
    store,
    vuetify: vuetifything,
    i18n,
    render: h => h(App)
  }).$mount('#app')
  /**
   * Load any 3rd party scripts required here
   */
  app.$scriptLoader.load('https://js.stripe.com/v3/')
}

const scriptLoader = {
  loaded: [],
  load(src) {
    if (this.loaded.indexOf(src) !== -1) {
      return
    }

    this.loaded.push(src)

    if (document) {
      const script = document.createElement('script')
      script.setAttribute('src', src)
      document.head.appendChild(script)
    }
  }
}

Vue.use({
  install() {
    Vue.prototype.$scriptLoader = scriptLoader
    Vue.prototype.$api = api
    Vue.prototype.$db = db
    Vue.prototype.$storage = storage
    Vue.prototype.$firebase = firebase
  }
})

firebase.auth().onAuthStateChanged(user => {
  if (!app) {
    createApp()
  }

  if (user) {
    store.commit('setAuthUser')

    if (user.emailVerified) {
      user.getIdTokenResult().then(token => {
        if (get(token, 'claims.tenant')) {
          store.dispatch('afterLogin')
        } else {
          store.dispatch('initUser')
        }
      })
    } else {
      router.push({ name: 'verify-email' })
    }
  }
})

firebase.auth().onIdTokenChanged(function (user) {
  if (user) {
    // User is signed in or token was refreshed.
    //console.log('USER TOKEN CHANGED!!!!', user)
  }
})







